import initLDClient from './initLDClient';
import FeatureFlags from './enums';

const getFeatureFlag = async (flag: FeatureFlags): Promise<boolean> => {
  const client = await initLDClient();
  return client?.variationDetail(flag).value ?? false;
};

export default getFeatureFlag;
